import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { ToastContainer } from "react-toastify";

import defaultValues from '../../constant/defaultValues';

import { useAuth } from '../../AuthProvider';
import { setAuthHeaders, showErrorMessage, showSuccessMessage, istTODate, buildPath, getPrefix } from '../../utils/common';
import { assignPlanToMember, FilterMembers, pdfToMember } from '../../actions/memberAction';
import { hideLoading, showLoading } from '../../actions/loaderAction';

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from "../../components/InputField";
import SubHeader from "../../components/SubHeader";
import MemberFilter from "../../components/memberFilter/memberFilter";
import Emitter from "../../utils/Emitter";
import DropDown from "../../components/DropDown";
import { getSubscriptionPlanList } from "../../actions/subscriptionPlanAction";
import { capitalize, debounce, find, isEmpty, size } from "lodash";
import ButtonAdd from "../../components/ButtonAdd";
import MediumPopup from "../../components/MediumPopup";
import Choosefile from "../../components/Choosefile";
import axiosInstance from '../../axiosHttp';
import API_URL from "../../constant/api.config";
import errorMessages from "../../constant/errorMessages";
import ToolipsCustom from '../../components/ToolipsCustom';
import CreditExceed from '../../components/common/CreditExceed';

import DatePickerField from '../../components/DatePickerField';
import RadioButtonField from "../../components/RadioButtonField";

import LargePopupCertificate from '../../components/LargePopupCertificate';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';

function Members(props) {
    const { admin, COMPANY_DEFAULTS } = defaultValues;
    const statusList = COMPANY_DEFAULTS.STATUS;
    const { user, isEndUser, isSuperAdmin, isViewer, isPreKYCUser, isDemoUser, isOpUser, isInqUser, isAdmin} = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const [smallmodalShow, setSmallModalShow] = useState(false);
    const [planList, setPlanList] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [assignedMemberId, setAssignedMemberId] = useState(0);
    const [assignedPlanId, setAssignedPlanId] = useState(0);
    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState("custom_order");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [mediummodalShow, setMediumModalShow] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [nodata, setNoData] = useState(false);
    const [verrors, setVErrors] = useState({});
    const [creditModalShow, setCreditModalShow] = useState(false);

    const [errors, setErrors] = useState({});
    const [assignPlanData, setAssignPlanData] = useState([]);
    const [datePlan, setDatePlan] = useState(null);
    const [badgePlan, setBadgeType] = useState(null);
    const [isButtonDisabled, setisButtonDisabled] = useState(false);
    const [datePlan0, setDatePlan0] = useState(null);

    const [largemodalShow, setLargeModalShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const [renewalList, setRenewalList] = useState([{
        label: "Select Renewal",
        value: ""
    }, {
        label: "Renewal 1",
        value: "RENEWAL_1"
    }, {
        label: "Renewal 2",
        value: "RENEWAL_2"
    }, {
        label: "Renewal 3",
        value: "RENEWAL_3"
    }, {
        label: "Renewal 4",
        value: "RENEWAL_4"
    }, {
        label: "Renewal 5",
        value: "RENEWAL_5"
    }]);

    const [selectedRenewal, setSelectedRenewal] = useState(null);

    const maxSize = 2 * 1024 * 1024; // 2mb

    const styleError = {
        display: "block",
    };

    const [searchFilterObj, setFilterObj] = useState({
        filterBy: "hs_code",
        offset: admin.OFFSET,
        limit: admin.LIMIT,
        columnName: "custom_order",
        sortDirection: admin.SORT_DIRECTION,
        filter_val: "",
        selected_companies: [],
        selected_hscodes: [],
        selected_services: [],
        selected_target_country: [],
        selected_origin_country: [],
        table_search: ""
    })

    const columns = [
        {
            name: 'Sr No',
            selector: (row, idx) => {
                return (
                    <>{offset + (idx + 1)}</>
                )
            },
            resizable: true,
            // width: "100px"
            width: "5%"
        },
        {
            name: 'Orex ID',
            selector: row => <div className='text-wrap'>{row.member_unique_number}</div>,
            resizable: true,
            // width: "150px"
            width: isSuperAdmin ? "13%" : "13%",
            // columnName: "member_unique_number",
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name}</div>,
            width: "35%",
            //  width: "13.5%",
            // columnName: "company_name",
            sortable: true
        },
        // {
        //    name: 'Name',
        //   selector: row => <div className="tbl-text-wrap-row"> {(row.first_name ? row.first_name : '') + ` ` + (row.last_name ? row.last_name : '')}</div>,
        //   resizable: true,
        //  width: "13.5%",
        // sortable: true
        //},
        //{
        //  name: 'Email',
        // selector: row => <div className='tbl-text-wrap-row'>{row.email}</div>,
        //resizable: true,
        // width: isSuperAdmin ? "14%" : "18%",
        // sortable: true
        //},
        {
            name: 'Trade Mode',
            selector: row => <div className='text-wrap'>{row.shipment_mode}</div>,
            resizable: true,
            //width: "150px"
            width: isSuperAdmin ? "13%" : "13%",
            // columnName: "shipment_mode",
            sortable: true
        },
        {
            name: 'Country',
            selector: row => <div className='text-wrap'>{row.country_name}</div>,
            resizable: true,
            // width: "150px"
            width: isSuperAdmin ? "19%" : "19%",
            // columnName: "country_name",
            sortable: true
        },
        // {
        //     name: 'Plan Name',
        //     selector: row => <div className='text-wrap'>{(row.plan_name == null) ? "Free" : row.plan_name}</div>,
        //     resizable: true,
        //     width: "9%",
        //     omit: isSuperAdmin === false,
        //     sortable: true
        // },
        // {
        //     name: 'Status',
        //     selector: (row) => {
        //         const rowStatus = statusList.find(option => option.value === row.status);
        //         return rowStatus.label;
        //     },
        //     resizable: true,
        //     width: "8%",
        //     omit: isEndUser === true
        // },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="text-wrap panle-action">
                    {(isSuperAdmin || isViewer || isOpUser || isInqUser) && <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id })}`}>

                        <ToolipsCustom subtitle="Edit" className="fa-regular fa-pen-to-square icon-pen border-0 panle-icon" classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                    </Link>
                    }

                    {
                        row.isViewAllowed ? <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: row.id })}`}>

                            <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 panle-icon" classNameChild={"data-table-tooltiop"}></ToolipsCustom>

                        </Link> : <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 panle-icon" classNameChild={"data-table-tooltiop"} onClick={handleCreditModal} ></ToolipsCustom>
                    }

                    {(isSuperAdmin || isOpUser) && row.status === 1 && <>
                        <ToolipsCustom
                            subtitle="Upgrade Plan"
                            className="fas fa-file-invoice-dollar icon-plan border-0 panle-icon "
                            classNameChild={"data-table-tooltiop password"}
                            onClick={() => handleAssignPlanClick(row)}

                        >

                        </ToolipsCustom>
                    </>
                    }

                    {(isSuperAdmin || isViewer || isOpUser || isAdmin) && row.plan_id > 0 && row.status === 1 && row.establish_date > 0 && row.badge !== null && row.plan_to_date !== null &&
                        <>
                            <ToolipsCustom
                                subtitle="Download Certificate"
                                className="fa-regular fa-file-pdf border-0 panle-icon "
                                classNameChild={"data-table-tooltiop download-certificate"}
                                onClick={() => handlePDFClick(row.id)}
                            >
                            </ToolipsCustom>
                        </>
                    }

                    {/* <button type="button" className="btn action-icon-btn m-0 p-0 " data-toggle="tooltip" data-placement="top" title="Upgrade Plan" onClick={() => handleAssignPlanClick(row)}>
                            <i className="fas fa-file-invoice-dollar icon-plan ms-1"></i>
                        </button> */}


                    {(isSuperAdmin || isViewer || isAdmin) && <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.PROFILE_HISTORY, { id: row.id })}`}>
                        <ToolipsCustom subtitle="History Log" className="fas fa-history icon-plan border-0 panle-icon" classNameChild={"data-table-tooltiop password"}></ToolipsCustom>
                    </Link>
                    }

                    {/* 
                    <button className="btn" >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                    </button> */}
                </div>
            ),
            // resizable: true,
            // width: "100px"
            width: "10%"
        }
    ];

    const handleCreditModal = () => {
        setCreditModalShow(true);
    }

    const handleImportFileChange = (e) => {

        let er = { ...verrors };
        const file = e.target.files[0];
        console.log('handleImportFileChange --> file --> ', file);
        console.log('handleImportFileChange --> file.type --> ', file.type);
        if (file == undefined) {
            er.csvFile = errorMessages.FIELD_REQUIRED;
        } else if (file != undefined && file.type != "text/csv") {
            er.csvFile = "The file must be of type csv";
        } else if (file != undefined && file.size > maxSize) {
            er.csvFile = "The file must be less than or equal to 2 MB";
        } else {
            er.csvFile = "";
        }

        setVErrors(er);
        setCsvFile(file);
    };

    const handleImportFileSubmit = (e) => {
        let resheaders = setAuthHeaders();
        let headers = resheaders.headers;
        headers['content-type'] = 'multipart/form-data';
        if (fileValidation()) {
            let fd = new FormData();
            fd.append("csvFile", csvFile);
            console.log("handleImportFileSubmit --> csvFile --> ", csvFile);
            axiosInstance
                .post(API_URL + "/import-member", fd, { headers })
                .then((response) => {
                    if (response.data.status == true) {
                        showSuccessMessage(response.data.message);
                        setMediumModalShow(false);
                        filterApplyOnMembers();
                    } else if (response.data.status == false) {
                        console.log("handleImportFileSubmit --> response --> ", response);
                        if (response.data.message == "Invalid Data") {
                            let newErrors = {};
                            newErrors.csvFile = response.data.message;
                            setVErrors(newErrors);
                        } else if (!isEmpty(response.data.error.csvFile)) {
                            let newErrors = {};
                            newErrors.csvFile = response.data.error.csvFile[0];
                            setVErrors(newErrors);
                        }
                    }
                });
        }
    };

    const fileValidation = () => {
        let er = { ...verrors };
        if (csvFile == "" || csvFile == null) {
            er.csvFile = errorMessages.FIELD_REQUIRED;
        } else if (csvFile.type != "text/csv") {
            er.csvFile = "The file must be of type csv";
        } else if (csvFile.size > maxSize) {
            er.csvFile = "The file must be less than or equal to 2 MB";
        } else {
            er.csvFile = "";
        }

        setVErrors(er);
        return !isEmpty(er.csvFile) ? false : true;
    };
    const handleSort = async (column, sortDirection) => {
        if (column.name != undefined && column.name != "" && column.name != null) {
            setColumnName(column.name);
            setSortDirection(sortDirection);
            // filterMemberData(
            //     admin.OFFSET,
            //     admin.LIMIT,
            //     current_page,
            //     column.name,
            //     sortDirection,
            //     searchTxt
            // );
            filterMemberData(
                offset,
                limit,
                current_page,
                column.name,
                sortDirection,
                searchTxt
            );
        }
    };

    const onSearchTextBoxChanged = debounce((e) => {
        //console.log("Search Val === ", e.target.value);
        // setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        //props.showLoading();
        if (searchVal.length >= 3 || searchVal.length == 0) {
            let sFilter = { ...searchFilterObj };
            sFilter.table_search = searchVal;
            setFilterObj(sFilter);
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName("custom_order");
            setSortDirection(admin.SORT_DIRECTION);
            setSearchTxt(e.target.value);
            setCurrentPage(1);
            setTableKey((prev) => prev + 1);
            // getRegisteredMembers(admin.OFFSET, admin.LIMIT, e.target.value);
            setTimeout(async () => {
                await filterMemberData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchVal);
                // props.hideLoading();
            }, 1500);

        }
    });

    /* const getRegisteredMembers = async (offset, limit, searchTxt) => {
        await props.showLoading();
        await props.getMembers(offset, limit, searchTxt).then((response) => {
            setMemberList(response.data);
            settotalRows(response.metadata.total);
        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong");
        });
        props.hideLoading();
    } */

    const filterMemberData = async (ofst = 0, lmt = 10, current_page = 1, columnName = "custom_order", sortDirection = "DESC", searchval = "") => {
        // console.log("filterMemberData  function args === ", ofst, lmt);
        console.log("column Name =====", columnName);
        props.showLoading();
        setNoData(false);
        let fObj = { ...searchFilterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            fObj.offset = ofst;
            fObj.limit = lmt;
            fObj.columnName = columnName;
            fObj.sortDirection = sortDirection;
            fObj.table_search = searchval;

            await props.FilterMembers(fObj).then((response) => {
                if (response) {
                    if (response.status === true) {
                        // console.log("filterMemberData Response of api in members page =========== ", response.data);
                        if (size(response.data) === 0) {
                            setNoData(true);
                        }
                        setMemberList(response.data);
                        settotalRows(response.metadata.total);
                    }
                }
            }).catch((err) => {
                console.log("Error ==== ", err);
            });

        }
        props.hideLoading();
    }

    const setMembersFilters = (newState) => {

        newState.table_search = "";
        setLimit(newState.limit);
        setOffset(newState.offset);

        setFilterObj(newState);

        setTableKey((prev) => prev + 1);
    }

    const filterApplyOnMembers = (filterObj) => {
        // console.log("FilterObj == ", filterObj); // set obj in state
        // filterObj.table_search = "";
        // setFilterObj(filterObj);
        filterMemberData(admin.OFFSET, admin.LIMIT, current_page, "custom_order", admin.SORT_DIRECTION, searchTxt);

    }

    const handlePDFClick = async (data) => {
        props.showLoading();

        await props.pdfToMember(data).then((response) => {
            if (response.status === true) {

                const pdfUrl = response.data.pdf_url;
                // const filename = response.data.filename;

                setPdfUrl(pdfUrl);

                setLargeModalShow(true);
                props.hideLoading();


            } else {
                console.log("False", response);
                showErrorMessage("Something went wrong!");
            }


        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong!");
        })


    }

    const handleAssignPlanClick = (data) => {
        setErrors({});
        // console.log("member_id =========== ", data);
        setAssignedMemberId(data.id);
        setAssignedPlanId(data.plan_id);

        if (data.plan_id === null) {
            setSelectedPlan({ label: "Free", value: "" });
            // getPlans(0, 20, "");
        } else {
            // getPlans(0, 20, data.plan_name);
        }
        getPlans(0, 20, "");

        /* if (isEmpty(planList)) {
            getPlans(0, 2, "");
        } else {
            console.log("handleAssignPlanClick else ... ");
            if (data.plan_id === null) {
                setSelectedPlan({});
            } else {
                const s_plan = planList.find((option) => option.value === data.plan_id);
                if (!isEmpty(s_plan)) {
                    setSelectedPlan(s_plan);
                } else {
                    getPlans(0, 2, data.plan_name);
                }
            }


        }*/
        if (data.plan_to_date) {
            setDatePlan(new Date(data.plan_to_date));
        } else {
            const currentDate = new Date();
            const nextYear = new Date(
                currentDate.getFullYear() + 1,
                currentDate.getMonth(),
                currentDate.getDate()
            );
            setDatePlan(nextYear);

        }
        if (data.establish_date > 0 || !isEmpty(data.establish_date)) {
            if (data.badge) {
                setBadgeType(data.badge);
            } else {
                if (data.plan_id === null) {
                    setBadgeType(null);
                } else {
                    if (data.plan_id !== null && data.badge) {
                        setBadgeType(data.badge);
                    } else {
                        const currentDate = new Date();
                        const establishYear = parseInt(assignPlanData.establish_date);
                        const monthsDifference = currentDate.getFullYear() - establishYear;
                        if (monthsDifference <= 2) {
                            setBadgeType("Basic");
                        }
                        else if (monthsDifference > 2 && monthsDifference <= 5) {
                            setBadgeType("Plus");
                        }
                        else if (monthsDifference > 5 && monthsDifference <= 10) {
                            setBadgeType("Pro");
                        }
                        else if (monthsDifference > 10) {
                            setBadgeType("Elite");
                        } else {
                            setBadgeType(null);
                        }
                    }
                }

            }
        } else {
            if (data.badge) {
                setBadgeType(data.badge);
            } else {
                setBadgeType(null);
            }

        }
        if (!isEmpty(data.plan_from_date) || data.plan_from_date) {
            setDatePlan0(new Date(data.plan_from_date));
        } else {
            setDatePlan0(new Date());
        }
        setisButtonDisabled(false);
        setAssignPlanData(data);
        setSmallModalShow(true);
    }

    const handlePlanChange = (val) => {
        setErrors({});
        // console.log("handlePlanChange ========== ", val);
        if ((val.label !== 'Free')) {
            if (!isEmpty(assignPlanData.plan_to_date) || assignPlanData.plan_to_date) {
                setDatePlan(new Date(assignPlanData.plan_to_date));
            } else {
                const currentDate = new Date();
                const nextYear = new Date(
                    currentDate.getFullYear() + 1,
                    currentDate.getMonth(),
                    currentDate.getDate()
                );
                setDatePlan(nextYear);
            }
            if (!isEmpty(assignPlanData.plan_from_date) || assignPlanData.plan_from_date) {
                setDatePlan0(new Date(assignPlanData.plan_from_date));
            } else {
                setDatePlan0(new Date());
            }

            if (assignPlanData.establish_date > 0 || !isEmpty(assignPlanData.establish_date)) {
                if (assignPlanData.badge) {
                    setBadgeType(assignPlanData.badge);
                } else {
                    const currentDate = new Date();
                    const establishYear = parseInt(assignPlanData.establish_date);
                    const monthsDifference = currentDate.getFullYear() - establishYear;
                    if (monthsDifference <= 2) {
                        setBadgeType("Basic");
                    }
                    else if (monthsDifference > 2 && monthsDifference <= 5) {
                        setBadgeType("Plus");
                    }
                    else if (monthsDifference > 5 && monthsDifference <= 10) {
                        setBadgeType("Pro");
                    }
                    else if (monthsDifference > 10) {
                        setBadgeType("Elite");
                    } else {
                        setBadgeType(null);
                    }

                }

            } else {
                if (assignPlanData.badge) {
                    setBadgeType(assignPlanData.badge);
                } else {
                    setBadgeType(null);
                }
            }


        } else {
            setDatePlan(null);
            setDatePlan0(null);
            setBadgeType(null);
        }
        setSelectedPlan(val);
        setAssignedPlanId(val.value);
    }

    const handlePlanInputChange = (val, actionMeta) => {
        // console.log("handlePlanInputChange ========= ", val);
        const { prevInputValue } = actionMeta;
        if (size(val) > 3) {
            getPlans(0, 20, val);
        } else if (size(val) === 0 && (prevInputValue !== val)) {
            getPlans(0, 20, "");
        }
    }

    const handleRenewalChange = (val) => {
        setSelectedRenewal(val);
    }

    const validation0 = async () => {
        setErrors({});
        let er = { ...errors };
        let flag = 0;
        if (selectedPlan?.label === 'Free') {
            if (isEmpty(assignPlanData.establish_date)) {
                flag = 1;
                er.establish_year = errorMessages.FIELD_REQUIRED;

            }
            setErrors(er);
            if (flag === 1) {
                return false;
            } else {
                return true;
            }

        }
        if (!datePlan) {
            flag = 1;
            er.datePlan = errorMessages.FIELD_REQUIRED;
        } else {
            er.datePlan = "";
        }


        if (!datePlan0) {
            flag = 1;
            er.datePlan0 = errorMessages.FIELD_REQUIRED;
        } else {
            er.datePlan0 = "";
        }


        if (!badgePlan) {
            flag = 1;
            er.badgePlan = errorMessages.FIELD_REQUIRED;
        } else {
            er.badgePlan = "";
        }


        if (isEmpty(assignPlanData.establish_date)) {
            flag = 1;
            er.establish_year = errorMessages.FIELD_REQUIRED;
        } else {
            er.establish_year = "";
        }


        setErrors(er);
        if (flag === 1) {
            return false;
        } else {
            return true;
        }

    }

    const assignPlan = async (e) => {
        // console.log("Plan id ============= ", selectedPlan, assignedMemberId);
        e.preventDefault();
        setisButtonDisabled(false);
        const isValid = await validation0();
        if (isValid) {
            let fromDate = null;
            let toDate = null;

            if (datePlan0) {
                fromDate = istTODate(datePlan0);
            }
            if (datePlan) {
                toDate = istTODate(datePlan);
            }
            console.log("datePlan0 ---- ", datePlan0, "From ---", fromDate);
            console.log("datePlan ---- ", datePlan, "to ---", toDate);
            const data = {
                plan_id: selectedPlan.value,
                member_id: assignedMemberId,
                fromDate: fromDate,
                toDate: toDate,
                badge: badgePlan,
                establish_year: assignPlanData.establish_date,
                no_of_renewal: selectedRenewal ? selectedRenewal.value : null
            }
            await props.assignPlanToMember(data).then((response) => {
                // console.log("Response ==== ", response);
                if (response.status === true) {
                    setisButtonDisabled(true);
                    showSuccessMessage(response.message);
                    setSmallModalShow(false);
                    filterMemberData(admin.OFFSET, admin.LIMIT, current_page, "custom_order", admin.SORT_DIRECTION, "");
                } else if (response.status === false) {
                    setisButtonDisabled(false);
                    if (response.message === 'All validation error.') {
                        let errObj = {};
                        if (response.error) {
                            if (response.error.toDate) {
                                errObj.datePlan = response.error.toDate[0];
                            }
                            if (response.error.badge) {
                                errObj.badgePlan = response.error.badge[0];
                            }
                            if (response.error.fromDate) {
                                errObj.datePlan0 = response.error.fromDate[0];
                            }
                            if (response.error.establish_year) {
                                errObj.establish_year = response.error.establish_year[0];
                            }

                        }
                        setisButtonDisabled(false);
                        setErrors(errObj);
                    } else {
                        setisButtonDisabled(false);
                        showErrorMessage("Something went wrong!");
                    }
                } else {
                    setisButtonDisabled(false);
                    showErrorMessage("Something went wrong!");
                }
            }).catch((err) => {
                setisButtonDisabled(false);
                console.log("Error ==== ", err);
                showErrorMessage("Something went wrong!");
            })

        }
    }

    const getPlans = async (offset, limit, searchTxt = "") => {
        await props.getSubscriptionPlans(offset, limit, "created_at", "DESC", "buyerOrSupplier", searchTxt).then((response) => {
            if (response.status === true) {
                let pList = response.data.map((val) => {
                    return {
                        label: val.name,
                        value: val.id
                    }
                });
                let dList = [{
                    label: "Free",
                    value: ""
                }];
                let newPLList = [...dList, ...pList];
                setPlanList(newPLList);
            }
        }).catch((err) => {
            console.log("Error ==== ", err);
        })
    }

    useEffect(() => {
        if (assignedMemberId > 0) {

            const planOpt = find(planList, { value: assignedPlanId });

            if (planOpt) {
                setSelectedPlan(planOpt);
            }
        }
    }, [planList]);


    /*useEffect(() => {
        let searchVal = searchTxt;
        if (searchVal.length >= 3 || searchVal.length <= 0) {
            // setOffset(admin.OFFSET);
            // setLimit(admin.LIMIT);
            // setColumnName(admin.COLUMN_NAME);
            // setSortDirection(admin.SORT_DIRECTION);
            // let sFilter = { ...searchFilterObj };
            // sFilter.table_search = searchVal;
            // console.log('sFilter----sFilter----sFilter--', sFilter);
            // setFilterObj(sFilter);
            // getRegisteredMembers(admin.OFFSET, admin.LIMIT, e.target.value);
            // setTimeout(async() => {
                 filterMemberData(admin.OFFSET, admin.LIMIT, "id", admin.SORT_DIRECTION);
            // }, 1500)
        }
    },[searchTxt]);*/

    useEffect(() => {
        async function fetchData() {
            // You can await here
            // getRegisteredMembers(offset, limit, searchTxt);
            initialRef.current = false;
            await filterMemberData(admin.OFFSET, admin.LIMIT, current_page, "custom_order", admin.SORT_DIRECTION, searchTxt);

        }
        if (initialRef.current === true) {
            //fetchData();
        }

    }, []);

    useEffect(() => {
        // Emitter.on("FILTER_MEMBERS", filterMemberData);
        Emitter.on("FILTER_MEMBERS", filterApplyOnMembers);
        Emitter.on("SET_FILTER_MEMBERS", setMembersFilters);
        return () => {
            Emitter.off("FILTER_MEMBERS", filterApplyOnMembers);
        };
    });



    const expandedRowComponent = ({ data }) => {
        const rowStatus = statusList.find(option => option.value === data.status);
        const statusLabel = rowStatus ? rowStatus.label : '';
        return (

            <div style={{ padding: '20px', borderTop: '1px solid #ddd' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '22px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px'
                }}>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Name:</strong> {(data.salutation ? data.salutation : '') + ` ` + (data.first_name ? data.first_name : '') + ` ` + (data.last_name ? data.last_name : '')}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Email:</strong> {data.email || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Plan Name:</strong> {(data.plan_name == null) ? "Free" : data.plan_name}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Established Year:</strong> {data.establish_date || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Status:</strong> {statusLabel}
                        </div>
                        {data.status == 4 && <div style={{ marginBottom: '15px' }}>

                            <strong style={{ fontWeight: 'bold' }}>Trading Country:</strong>

                            {(data.trade_countries || '-').split(' ').length > 10 ? (
                                <>
                                    {data.trade_countries.split(' ').slice(0, 10).join(' ')}...
                                    <ToolipsCustom classNameChild={"tooltip-responsive logistic-member"} title="?" subtitle={data.trade_countries} />
                                </>
                            ) : (
                                data.trade_countries
                            )}
                        </div>
                        }

                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Phone:</strong> {data.phone || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Country:</strong> {data.country_name || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Company Size:</strong> {data.company_size || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Trade Mode: </strong>
                            {(data.shipment_mode) && data.shipment_mode} {(data.shipment_mode) && (data.shipment_mode === 'Manufacturer' || data.shipment_mode === 'Trader') ? '(' + capitalize(data.trade_mode_type) + ')' : ''}
                        </div>
                        {data.status === 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Reason:</strong> {data.reason || '-'}
                        </div>
                        }
                        {data.status != 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        }


                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Mobile:</strong> {data.mobile || '-'}
                        </div>
                        {/* <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div> */}
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Industry: </strong> {data.industry_name ? data.industry_name : '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>What You Want With Us:</strong> {data.with_us || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Website:</strong> {data.website || '-'}
                        </div>
                        {data.status === 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        }
                        {data.status != 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Trading Country:</strong>

                            {(data.trade_countries || '-').split(' ').length > 10 ? (
                                <>
                                    {data.trade_countries.split(' ').slice(0, 10).join(' ')}...
                                    <ToolipsCustom classNameChild={"tooltip-responsive logistic-member"} title="?" subtitle={data.trade_countries} />
                                </>
                            ) : (
                                data.trade_countries
                            )}

                        </div>
                        }

                    </div>
                </div>
            </div>
        );
    };

    // import CSV Popup

    const openImportCsv = () => {
        setVErrors({});
        setCsvFile(null);
        setMediumModalShow(true);
    };

    const disabledDate = (date) => {
        const today = new Date();
        return date < today;
    };


    const handleBadgeTypeChange = (e, type) => {
        setBadgeType(type);
    }

    const handleDateChange = (date) => {
        setDatePlan(date)
    }

    // const handleFocusOut0 = () => {

    //     if(!selectedPlan || !selectedPlan.value){
    //         setErrors((prevErrors) => ({
    //             ...prevErrors,
    //             [`plan_type`]: errorMessages.FIELD_REQUIRED,
    //           }));
    //     } else {
    //           setErrors ((prevErrors) => ({
    //             ...prevErrors,
    //             [`plan_type`]: "",
    //           }));
    //         }
    // }

    const handleBlur = (value) => {

        if (!value) {
            setErrors(prev => ({
                ...prev,
                datePlan: errorMessages.FIELD_REQUIRED,
            }));
            //  setisButtonDisabled(true);
        } else {
            setErrors(prev => ({
                ...prev,
                datePlan: "",
            }));
            // setisButtonDisabled(false);
        }


    };

    const handleBlur0 = (value) => {
        if (!value) {
            setErrors(prev => ({
                ...prev,
                datePlan0: errorMessages.FIELD_REQUIRED,
            }));
            // setisButtonDisabled(true);
        } else {
            setErrors(prev => ({
                ...prev,
                datePlan0: "",
            }));
            //  setisButtonDisabled(false);
        }

    };

    useEffect(() => {
        if (datePlan0 === null || datePlan0 === "" || datePlan === null || datePlan === "") {
            setisButtonDisabled(true);
        } else {
            setisButtonDisabled(false);
        }

        if (selectedPlan?.label === 'Free') {
            setisButtonDisabled(false);
        }

    }, [datePlan0, datePlan, selectedPlan]);


    return (<>

        <div className='data-table-main member-table'>

            <div className="AcSimpleTable">
                <SubHeader
                    layer1="Supplier Directory"
                    layer2=""
                    layer3="List"
                    pageName="Suppliers"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />

                <div className='filter-section'>
                    <MemberFilter />
                </div>

                <div className='card1'>

                    <div className='table-header-name'>
                        <h5 className='table-text'>List</h5>
                        <div className='d-flex justify-content-between align-items-center p-3'>
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25 '
                                onKeyUp={onSearchTextBoxChanged}
                                // onChange={onSearchTextBoxChanged}
                                autoComplete="off"
                            ></InputField>

                            {isSuperAdmin && (
                                <ButtonAdd className='export-btn ms-2' type="button" onClick={openImportCsv}>
                                    <i className="fa-solid fa-upload"></i> Import csv
                                </ButtonAdd>
                            )}
                            {(isSuperAdmin || isViewer) && (
                                <Link to={`/${getPrefix(user)}${privateRoutePaths.MEMBERS_FORM.path}`}>
                                    <ButtonAdd
                                        type="button"
                                        className="btn-add">
                                        <i className="fa-solid fa-circle-plus"></i> Enrollment Form
                                    </ButtonAdd>
                                </Link>
                            )}
                        </div>

                    </div>
                    <div className="table-wrapper">
                        <div className="table-container">
                            {memberList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={memberList}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={filterMemberData}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    // setColumnName={setColumnName}
                                    // setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    searchTxt={searchTxt}
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    setCurrentPage={setCurrentPage}
                                    expandableRows
                                    expandableRowsComponent={expandedRowComponent}
                                    noData={nodata}
                                />
                            )}
                        </div>
                    </div>

                </div>

                <MediumPopup
                    title="Assign Plan"
                    mediummodalShow={smallmodalShow}
                    setMediumModalShow={setSmallModalShow}
                    onSubmit={assignPlan}
                    closeButtonLabel="Cancel"
                    okButtonLabel="Assign"
                    className="btn-assign"
                    disabled={isButtonDisabled}
                >
                    <form onSubmit={assignPlan}>

                        <div className='row my-3'>

                            <div className="col-xl-6 mt-2">
                                <label className='popup-input-lable field-required'>Established Year</label>
                                <InputField
                                    className='w-100'
                                    readOnly
                                    value={assignPlanData.establish_date}
                                    disabled="true"
                                />
                                {errors.establish_year && (
                                    <p
                                        className="invalid-feedback"
                                        style={{ display: "block" }}
                                    >
                                        {errors.establish_year}
                                    </p>
                                )}
                            </div>



                            <div className="col-xl-6 mt-1">
                                <label className='popup-input-lable field-required'>Plan</label>
                                <DropDown
                                    options={planList}
                                    placehoder="Select Plan"
                                    onChange={handlePlanChange}
                                    onInputChange={handlePlanInputChange}
                                    name="plan_id"
                                    value={selectedPlan}
                                // onFocus={handleFocusOut0}
                                ></DropDown>

                                {/* {errors.plan_type && (
                                <p
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                >
                                    {errors.plan_type}
                                </p>
                            )} */}
                            </div>

                            {selectedPlan?.value !== undefined && selectedPlan?.value !== "" && (
                                <>
                                    <div className="col-xl-6 mt-2">
                                        <label className='popup-input-lable field-required'>From Date</label>
                                        <DatePickerField
                                            format="yyyy-MM-dd"
                                            className='w-100'
                                            // defaultValue={new Date()}
                                            value={datePlan0}
                                            onChange={(value) => {
                                                setDatePlan0(value);
                                                if (datePlan && value && value >= datePlan) {
                                                    setDatePlan(null);
                                                }
                                                handleBlur0(value);
                                            }}
                                            onBlur={() => handleBlur0(datePlan0)}
                                            onOpenChange={(open) => {
                                                if (!open) handleBlur0(datePlan0);
                                            }}
                                            disabledDate={(current) => {
                                                return datePlan && current >= datePlan;
                                            }}
                                        />
                                        {errors.datePlan0 && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.datePlan0}
                                            </p>
                                        )}
                                    </div>

                                    <div className="col-xl-6 mt-2">
                                        <label className='popup-input-lable field-required'>To Date</label>

                                        <DatePickerField
                                            format="yyyy-MM-dd"
                                            className="w-100"
                                            value={datePlan}
                                            onChange={(value) => {
                                                setDatePlan(value);
                                                if (datePlan0 && value && value <= datePlan0) {
                                                    setDatePlan0(null);
                                                }
                                                handleBlur(value);
                                            }}
                                            onBlur={() => handleBlur(datePlan)}
                                            onOpenChange={(open) => {
                                                if (!open) handleBlur(datePlan);
                                            }}
                                            disabledDate={(current) => {
                                                return datePlan0 && current <= datePlan0;
                                            }}
                                        />

                                        {errors.datePlan && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.datePlan}
                                            </p>
                                        )}
                                    </div>


                                    <div className="col-xl-6 mt-3">
                                        <label className='popup-input-lable field-required'>Badge</label>

                                        <div className='d-flex'>
                                            <div className='mt-2'>
                                                <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Basic")} name="badgeType" checked={badgePlan === "Basic"} />
                                                <label className=''>BASIC</label>
                                            </div>
                                            <div className='mt-2'>
                                                <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Plus")} name="badgeType" checked={badgePlan === "Plus"} />
                                                <label className=''>PLUS</label>
                                            </div>

                                            <div className='mt-2'>
                                                <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Pro")} name="badgeType" checked={badgePlan === "Pro"} />
                                                <label className=''>PRO</label>
                                            </div>
                                            <div className='mt-2'>
                                                <RadioButtonField onChange={(e) => handleBadgeTypeChange(e, "Elite")} name="badgeType" checked={badgePlan === "Elite"} />
                                                <label className=''>ELITE</label>
                                            </div>

                                        </div>

                                        {errors.badgePlan && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.badgePlan}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-3'>
                                        <label className='popup-input-lable'>No of Renewal</label>
                                        <DropDown
                                            options={renewalList}
                                            placehoder="Select Renewal"
                                            onChange={handleRenewalChange}
                                            name="renewal"
                                            value={selectedRenewal}
                                        // onFocus={handleFocusOut0}
                                        ></DropDown>
                                    </div>
                                </>
                            )}

                        </div>

                    </form>
                </MediumPopup>

            </div>


            <MediumPopup
                title={"Import File"}
                mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow}
                onSubmit={handleImportFileSubmit}
                okButtonLabel={"Import"}
                closeButtonLabel="Cancel"
            >
                <Choosefile
                    className={`form-control`}
                    type="file"
                    accept="text/csv"
                    // value={csvFile}
                    onChange={handleImportFileChange}
                // name={`shipmentcsv`}
                />
                <p className="upload-info">Allowed CSV. Max size of 2 MB</p>
                {verrors.csvFile && (
                    <span className="company-required" style={styleError}>
                        {verrors.csvFile}
                    </span>
                )}
            </MediumPopup>

            {/** Credit Exceed Popup */}
            <MediumPopup
                title={"Oops! No More Credits Left Today"}
                mediummodalShow={creditModalShow}
                setMediumModalShow={setCreditModalShow}
                titlePosition="center-align-title"
            >
                <CreditExceed isSticky={false} />
            </MediumPopup >

            <LargePopupCertificate
                LargeModalShow={largemodalShow}
                setLargeModalShow={setLargeModalShow}
                pdfUrl={pdfUrl}
            ></LargePopupCertificate>

            {/* <ToastContainer /> */}
        </div >

    </>)
}

const mapStateToProps = state => {

    return {
        // member_list: state.member.memberlist,
        // authError: state.auth.errorMessages
    }
}
const mapDispatchToProps = dispatch => {
    return {
        // getMembers: (offset, limit, searchTxt) => dispatch(getMemberList(offset, limit, searchTxt)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        FilterMembers: (filterData) => dispatch(FilterMembers(filterData)),
        getSubscriptionPlans: (offset, limit, columnName, sortDirection, type, searchTxt) =>
            dispatch(getSubscriptionPlanList(offset, limit, columnName, sortDirection, type, searchTxt)),
        assignPlanToMember: (data) => dispatch(assignPlanToMember(data)),
        pdfToMember: (data) => dispatch(pdfToMember(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Members);
